import ReactDOM from "react-dom/client";

// CSS
import "./styles/index.css";

import App from "./App";

import { store } from "./app/store";
import { Provider } from "react-redux";

// Time
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";

// Components
import { Toast } from "elseware-ui";

TimeAgo.addDefaultLocale(en);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Toast />
    <App />
  </Provider>
);
